<script>
import Vue from 'vue'
import Api from '@/components/Api/Api'
let rfcMostrador = 'XAXX010101000'
let correoMostrador = 'mostrador@mail.tk'
let nombreMostrador = 'Publico en general'
export default new Vue({
  name: 'Cliente',
  data() {
    return {
      form: [{
        label: 'Nombre',
        field: 'nombre',
        size: 12,
        required: true
      }, {
        label: 'RFC',
        field: 'rfc',
        size: 12,
        required: false
      }, {
        label: 'Teléfono',
        field: 'telefono',
        size: 6,
        required: true
      }, {
        label: 'Correo',
        field: 'email',
        size: 6,
        required: false
      }, {
        label: 'Correo secundario',
        field: 'email2',
        size: 6,
        required: false
      }, {
        label: 'Correo secundario',
        field: 'email3',
        size: 6,
        required: false
      }, {
        label: 'Calle',
        field: 'calle',
        size: 8,
        required: false
      }, {
        label: 'Num.Ext.',
        field: 'numeroExterior',
        size: 2,
        required: false
      }, {
        label: 'Num.Int.',
        field: 'numeroInterior',
        size: 2,
        required: false
      }, {
        label: 'Colonia',
        field: 'colonia',
        size: 7
      }, {
        label: 'C.P.',
        field: 'codigoPostal',
        size: 5,
        required: true
      }, {
        label: 'Estado',
        field: 'estado',
        size: 6
      }, {
        label: 'Municipio',
        field: 'municipio',
        size: 6
      }]
    }
  },
  methods: {
    formulario() {
      return this.form
    },
    mostrador() {
      return new Promise(async (resolve, reject) => {
        let clienteMostrador = await Api.find('cliente', ['rfc,eq,' + rfcMostrador])
        if (clienteMostrador && clienteMostrador.length > 0) {
          resolve(clienteMostrador[0])
        } else {
          toast("No ha sido instalado el cliente de mostrador. Haciendolo ahora. ")
          let cl = {
            nombre: nombreMostrador,
            rfc: rfcMostrador,
            email: correoMostrador,
            rol: 'cliente',
            fechaAlta: new Date().getTime()
          }
          let s = Api.save('cliente', cl)
          console.log("Guardado cliente mostrador", s._id)
          resolve(s)
        }
      })
    },
    async lista(forzar) {
      forzar = forzar && true
      let clientes
      try {
        clientes = []
        for (let key in localStorage) {
          if (key.startsWith('hb3.cliente.'))
            clientes.push(Api.fetchLocal(key))
        }
        if (clientes.length == 0)
          throw new Error('Caché vacía')
        if (forzar)
          throw new Error('Descarga de lista completa forzada')
      } catch (e) {
        if (typeof e != 'string')
          console.warn("ECLIENTES", e)
        try {
          clientes = await Api.get('cliente')
        } catch (e) {}
        for (let p of clientes)
          if (p && p._id) {
            Api.saveLocal('hb3.cliente.' + p._id, p)
          }
      }
      clientes = clientes.sort((a, b) => {
        return a.nombre > b.nombre ? 1 : -1
      })
      return new Promise((resolve) => {
        console.log("Clientes lista", clientes.length)
        resolve(clientes)
      })
    },
    lista2() {
      return new Promise((resolve, reject) => {
        Api.get('cliente').then(c => {
          resolve(c)
        }, e => {
          console.error("ELISTA", e)
          resolve([])
        })
      })
    },
    async obtener(id) {
      let cliente = {}
      try {
        if (!id || id == '')
          throw new Error('Cliente no especificado: ' + id + ' ' + typeof id)
        let clienteEnCache = Api.fetchLocal('hb3.cliente.' + id)
        if (clienteEnCache && clienteEnCache._id) {
          cliente = clienteEnCache
          //console.log("Cliente recuperado de cache", id, cliente.nombre)
        } else {
          cliente = await Api.get('cliente', id)
          Api.saveLocal('hb3.cliente.' + id, cliente)
        }
      } catch (e) {
        console.error('No se pudo obtener el cliente', e)
      }
      return new Promise((resolve) => {
        resolve(cliente)
      })
    },
    guardar(c) {
      return Api.save('cliente', c)
    },
    eliminar(c) {
      if (typeof c == 'string')
        return Api.delete('cliente', c)
      else if (c._id)
        return Api.delete('cliente', c._id)
    }
  }
})
</script>
